/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/array-type */
import {SearchOutlined} from '@ant-design/icons';
import type {InputRef} from 'antd';
import {Input, Table as TableAnt} from 'antd';
import {ColumnType, ColumnsType} from 'antd/es/table';
import React, {useEffect, useRef, useState} from 'react';

import {
  blockAccessTypes,
  blockModelMessages
} from '../../constants/blockPageConstatnts';
import InformativeText from '../../constants/InformativeText';
import {SampleExcel} from '../../constants/SampleExcel';
import {
  OPKey,
  OPLabel
} from '../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import SupplierMapView from '../../pages/orgManager/Utils/SupplierInfo/SupplierMapView';
import {uploadTypes} from '../../services/constants/uploadTypes';
import {APITypeEnum} from '../../services/interface/tableAPIType';
import cityJSON from '../../services/modules/JSON/cityJSON';
import countryJSON from '../../services/modules/JSON/country';
import productsJSON from '../../services/modules/JSON/products';
import statesJSON from '../../services/modules/JSON/statesJSON';
import supplierTypeJSON from '../../services/modules/JSON/supplierType';
import vehicleType from '../../services/modules/JSON/vehicleType';
import supplierInfo from '../../services/modules/OM/supplierInfoDetails';
import getTotalUserCount from '../../services/modules/User/totalUserCount';
import {
  accessModule,
  countModule
} from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import mapAndFilter from '../../utils/mapCountry';
import {
  // getAvailableDataLimit,
  getModuleDataLimit,
  hasMaxLimitReached
} from '../../utils/SubscriptionHelper';
import BlockAccessPage from '../BlockAccess/BlockAccessPage';
import {objTypes} from '../DrawerForm/Constants/commonConstants';
import DrawerForm from '../DrawerForm/Utils/DrawerForm';
import {
  facilityKeyLabel,
  yearKeyLabel
} from '../Forms/Constants/IP/commonKeyLabel';
import {
  upstreamKey,
  upstreamLabel
} from '../Forms/Constants/IP/UpstreamKeyLabel';
import SupplierInfo from '../Forms/SupplierInfoForm';
import JobsModal from '../Jobs/JobsModal';
import Loader from '../Loader/Loader';

import {Title} from './Constants/Common';
import {defaultCol} from './Interface/ITable';
import ActionsButton from './Utils/ActionsButton';
import TableTitleHeader from './Utils/TableTitleHeader';

const DownSupplier: React.FC<{
  isListView: boolean;
  selectedYear: string;
  facilityId: string;
}> = ({selectedYear, facilityId, isListView}) => {
  interface DataType {
    key: React.Key;
    _id: string;
    name: string;
    mobile: string;
    email: string;
    partnerType: number;
    address: string;
    pincode: number;
    country: number;
    state: number;
    city: number;
  }

  const [dataSource, setDataSource] = useState<DataType[]>([]);

  const [showModel, setShowModel] = useState(false);
  const [showJobs, setShowJobs] = useState(false);
  const [editData, setEditData] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [allJSON, setAllJSON] = useState(false);

  const countryOption = useJSONStore.getState().country;
  const stateOption = useJSONStore.getState().states;
  const cityOption = useJSONStore.getState().city;

  const {supplierType, products} = useJSONStore.getState();

  const type = 'downstream';

  useEffect(() => {
    if (!facilityId || !selectedYear) {
      setDataSource([]);
    }
    if (facilityId && selectedYear && allJSON) {
      setIsRefresh(true);
      supplierInfo(
        APITypeEnum.GET_ALL,
        undefined,
        `${facilityId}/${selectedYear}/${type}`
      )
        .then((res) => {
          setDataSource(
            res.map((data: any) => {
              return {
                ...data,
                fullAddress: `${data?.[upstreamKey.ADDRESS]}, ${cityOption.find(
                  (item: any) => {
                    return item.value === data?.[upstreamKey.CITY];
                  }
                )?.label}, ${stateOption.find((item: any) => {
                  return item.value === data?.[upstreamKey.STATE];
                })?.label}, ${countryOption.find((item: any) => {
                  return item.value === data?.[upstreamKey.COUNTRY];
                })?.label}, ${data.pincode}`
              };
            }) ?? []
          );
        })
        .catch(() => {
          setDataSource([]);
        })
        .finally(() => {
          setIsRefresh(false);
        });
    }
  }, [facilityId, selectedYear, allJSON]);

  useEffect(() => {
    setIsRefresh(true);
    Promise.all([
      vehicleType(),
      countryJSON(),
      statesJSON(),
      cityJSON(),
      productsJSON(),
      supplierTypeJSON(),
      getTotalUserCount()
    ])
      .catch(() => {})
      .finally(() => {
        setIsRefresh(false);
        setAllJSON(true);
      });
  }, []);

  useEffect(() => {
    if (refresh) {
      setIsRefresh(true);
      Promise.all([
        supplierInfo(
          APITypeEnum.GET_ALL,
          undefined,
          `${facilityId}/${selectedYear}/${type}`
        ),
        getTotalUserCount()
      ])
        .then(([res]) => {
          setDataSource(
            res.map((data: any) => {
              return {
                ...data,
                fullAddress: `${data?.[upstreamKey.ADDRESS]}, ${cityOption.find(
                  (item: any) => {
                    return item.value === data?.[upstreamKey.CITY];
                  }
                )?.label}, ${stateOption.find((item: any) => {
                  return item.value === data?.[upstreamKey.STATE];
                })?.label}, ${countryOption.find((item: any) => {
                  return item.value === data?.[upstreamKey.COUNTRY];
                })?.label}, ${data.pincode}`
              };
            }) ?? []
          );
        })
        .catch(() => {
          setDataSource([]);
        })
        .finally(() => {
          setIsRefresh(false);
          setRefresh(false);
        });
    }
  }, [refresh]);

  const handleDelete = (_id: string[] | string) => {
    supplierInfo(APITypeEnum.DELETE_ALL, {
      suppliers: _id,
      year: selectedYear,
      facility: facilityId
    })
      .then(() => {
        setSelectedRowKeys([]);
        setRefresh(true);
      })
      .catch(() => {});
  };

  const downSupplierKeyLabel = [
    {
      key: yearKeyLabel.key,
      label: yearKeyLabel.label,
      type: objTypes.string
    },
    {
      key: facilityKeyLabel.key,
      label: facilityKeyLabel.label,
      type: objTypes.facilityFormPreview,
      relatedKey: yearKeyLabel.key,
      isMaker: hasUserRole(UserRole.Maker_Role)
    },
    {
      label: upstreamLabel.SUPPLIER_TYPE,
      type: objTypes.text,
      text: 'Downstream'
    },
    {
      key: upstreamKey.SUPPLIER_NAME,
      label: upstreamLabel.SUPPLIER_NAME,
      type: objTypes.string
    },
    {
      key: upstreamKey.FIRST_NAME,
      label: upstreamLabel.FIRST_NAME,
      type: objTypes.string
    },
    {
      key: upstreamKey.LAST_NAME,
      label: upstreamLabel.LAST_NAME,
      type: objTypes.string
    },
    {
      key: upstreamKey.MOBILE,
      label: upstreamLabel.MOBILE,
      type: objTypes.string
    },
    {
      key: upstreamKey.EMAIL,
      label: upstreamLabel.EMAIL,
      type: objTypes.string
    },
    {
      key: upstreamKey.ADDRESS,
      label: upstreamLabel.ADDRESS,
      type: objTypes.string
    },
    {
      key: upstreamKey.COUNTRY,
      label: upstreamLabel.COUNTRY,
      type: objTypes.json,
      format: countryOption
    },
    {
      key: upstreamKey.STATE,
      label: upstreamLabel.STATE,
      type: objTypes.json,
      format: stateOption
    },
    {
      key: upstreamKey.CITY,
      label: upstreamLabel.CITY,
      type: objTypes.json,
      format: cityOption
    },
    {
      key: upstreamKey.PINCODE,
      label: upstreamLabel.PINCODE,
      type: objTypes.string
    },
    {
      key: upstreamKey.supplierType,
      label: upstreamLabel.supplierType,
      type: objTypes.json,
      format: supplierType
    },
    {
      key: upstreamKey.goodsSupplied,
      label: upstreamLabel.goodsSupplied,
      type: objTypes.json,
      format: products,
      renderType: 'multi'
    },
    {
      key: OPKey.TAX,
      label: OPLabel.GST,
      type: objTypes.string,
      relatedKey: upstreamKey.COUNTRY
    }
  ];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sorter = (key: keyof DataType) => {
    return {
      sorter: (a: DataType, b: DataType) => {
        const valueA = a[key];
        const valueB = b[key];
        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return valueA - valueB;
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return valueA.localeCompare(valueB);
        }

        return 0;
      }
    };
  };

  const searchInput = useRef<InputRef>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const SearchFilter = (
    title: string,
    dataIndex: keyof DataType
  ): defaultCol & ColumnType<DataType> => {
    return {
      filterDropdown: ({selectedKeys, setSelectedKeys, confirm}) => {
        return (
          <div
            style={{padding: 8}}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          >
            <Input
              ref={searchInput}
              value={selectedKeys[0]}
              placeholder={`Search ${title}`}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              allowClear
            />
          </div>
        );
      },
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => {
        return record[dataIndex]
          ?.toString()
          .toLowerCase()
          .includes(value?.toString().toLowerCase());
      },
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      }
    };
  };

  const columns: (defaultCol & ColumnsType<DataType>[0])[] = [
    {
      title: upstreamLabel.SUPPLIER_NAME,
      dataIndex: upstreamKey.SUPPLIER_NAME,
      // ...sorter(upstreamKey.SUPPLIER_NAME as keyof DataType),
      //   width: '100px',
      ...SearchFilter(
        upstreamLabel.SUPPLIER_NAME,
        upstreamKey.SUPPLIER_NAME as keyof DataType
      )
    },
    {
      title: upstreamLabel.MOBILE,
      dataIndex: upstreamKey.MOBILE,
      //   width: '120px'
      type: 'number'
    },
    {
      title: upstreamLabel.EMAIL,
      dataIndex: upstreamKey.EMAIL,
      // ...sorter(upstreamKey.EMAIL as keyof DataType),
      //   width: '100px',
      ...SearchFilter(upstreamLabel.EMAIL, upstreamKey.EMAIL as keyof DataType)
    },
    // {
    //   title: upstreamLabel.PARTNER_TYPE,
    //   dataIndex: upstreamKey.PARTNER_TYPE,

    //   type: 'select',
    //   ...sorter(upstreamKey.PARTNER_TYPE as keyof DataType),
    //   //   width: '100px',
    //   filterer: partnerType,
    //   filters: partnerType?.map((item) => {
    //     return {text: item.label, value: item.value};
    //   }),
    //   onFilter: (value, record) => {
    //     return record[upstreamKey.PARTNER_TYPE as keyof DataType] === value;
    //   },
    //   render: (value) => {
    //     return (
    //       <>
    //         {
    //           partnerType?.find((item) => {
    //             return item.value === value;
    //           })?.label
    //         }
    //       </>
    //     );
    //   }
    // },
    {
      title: upstreamLabel.ADDRESS,
      dataIndex: 'fullAddress',
      editable: true,
      // ...sorter(upstreamKey.ADDRESS as keyof DataType),
      //   width: '100px',
      ...SearchFilter(upstreamLabel.ADDRESS, 'fullAddress' as keyof DataType),
      render: (value) => {
        return <div>{value}</div>;
      }
    },
    {
      title: upstreamLabel.supplierType,
      dataIndex: upstreamKey.supplierType,
      editable: true,
      type: 'select',
      filterer: supplierType,
      filters: mapAndFilter(
        dataSource,
        supplierType,
        upstreamKey.supplierType
      ).map((item) => {
        return {text: item.label, value: item.value};
      }),
      onFilter: (value, record: any) => {
        return record[upstreamKey.supplierType] === value;
      },
      render: (value) => {
        return (
          <>
            {
              supplierType.find((item) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    // {
    //   title: upstreamLabel.PINCODE,
    //   dataIndex: upstreamKey.PINCODE,
    //   editable: true,
    //   // ...sorter(upstreamKey.PINCODE as keyof DataType),
    //   //   width: '100px',
    //   ...SearchFilter(
    //     upstreamLabel.PINCODE,
    //     upstreamKey.PINCODE as keyof DataType
    //   )
    // },
    // {
    //   title: upstreamLabel.COUNTRY,
    //   dataIndex: upstreamKey.COUNTRY,
    //   editable: true,
    //   // ...sorter(upstreamKey.COUNTRY as keyof DataType),
    //   //   width: '100px',
    //   type: 'select',
    //   filterer: country,
    //   filters: mapAndFilter(dataSource, country, upstreamKey.COUNTRY).map(
    //     (item) => {
    //       return {text: item.label, value: item.value};
    //     }
    //   ),
    //   onFilter: (value, record) => {
    //     return record[upstreamKey.COUNTRY as keyof DataType] === value;
    //   },
    //   render: (value) => {
    //     return (
    //       <>
    //         {
    //           country.find((item) => {
    //             return item.value === value;
    //           })?.label
    //         }
    //       </>
    //     );
    //   }
    // },
    ...(!hasUserRole(UserRole.View_Only)
      ? ([
          {
            title: Title.actionTitle,
            dataIndex: 'operation',
            type: '',
            fixed: 'right',
            width: '200px !important',
            render: (value: any, record: any) =>
              dataSource.length >= 1 ? (
                <ActionsButton
                  record={record}
                  setShowModel={setShowModel}
                  setEditData={setEditData}
                  setIsEdit={setIsEdit}
                  handleDelete={handleDelete}
                  isConfigurator={true}
                />
              ) : null
          }
        ] as any)
      : [])
  ];

  return (
    <div>
      <TableTitleHeader
        title="Supplier Info"
        filter={{facilityId, selectedYear}}
        addButton={{
          setShowModel,
          setIsEdit,
          buttonTitle: 'Add Downstream Supplier'
        }}
        sampleDownload={{href: SampleExcel.DownSupplier}}
        jobs={{setShowJobs, uploadType: uploadTypes.SupplierDown}}
        deleteButton={{selectedRowKeys, handleDelete}}
        refresh={{setRefresh}}
        tooltip={InformativeText.supplierInfo.downMain}
        shouldEdit={!hasUserRole(UserRole.View_Only)}
        blockAddition={hasMaxLimitReached(countModule.externalStakeholders)}
        shouldDisable={!isRefresh}
        // accessModuleType={accessModule.externalStakeholders}
        // accessModuleDataLimit={getAvailableDataLimit(
        //   countModule.externalStakeholders
        // )}
      />
      <JobsModal
        open={showJobs}
        onCancel={() => {
          setShowJobs(false);
          setRefresh(true);
        }}
        type={uploadTypes.SupplierDown}
        details={`${facilityId}/${selectedYear}`}
      />
      {isListView ? (
        <TableAnt
          // getPopupContainer={(triggerNode) =>
          //   triggerNode.closest(
          //     '.ant-modal, .ant-drawer, [style*="position"]'
          //   ) as HTMLElement
          // }
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys,
            onChange: (selectedKey: React.Key[], selectedRow: DataType[]) => {
              setSelectedRowKeys(
                selectedRow.map((item) => {
                  return item._id;
                })
              );
            }
          }}
          rowKey="_id"
          dataSource={dataSource}
          columns={columns as any}
          scroll={{x: 'auto'}}
          loading={{
            indicator: <Loader />,
            spinning: allJSON ? isRefresh : true
          }}
        />
      ) : (
        <SupplierMapView
          data={dataSource}
          setEditData={setEditData}
          setIsEdit={setIsEdit}
          handleDelete={handleDelete}
          setShowModel={setShowModel}
          type="down"
          isLoading={allJSON ? isRefresh : true}
        />
      )}

      {hasMaxLimitReached(countModule.externalStakeholders) ? (
        <div style={{marginTop: 15, marginBottom: 10}}>
          <BlockAccessPage
            blockedType={blockAccessTypes.PARTIAL}
            messageTitle={
              blockModelMessages.externalStakeholder.title.limitReached
            }
            messageDescription={blockModelMessages.externalStakeholder.description.limitReached(
              getModuleDataLimit(accessModule.externalStakeholders)
            )}
          />
        </div>
      ) : null}

      <DrawerForm
        open={showModel}
        onCancel={() => {
          setShowModel(false);
        }}
        setRefresh={setRefresh}
        data={isEdit ? editData : undefined}
        FormComponent={
          <SupplierInfo type="down" data={isEdit ? editData : undefined} />
        }
        API={supplierInfo}
        idKey={`${facilityId}/${selectedYear}`}
        table={true}
        type={{key: 'type', value: type}}
        isSupplierInfo={true}
        stepsTitle={['General Details', 'Supplier Details']}
        formPreview={downSupplierKeyLabel}
        isConfigurator={true}
      />
    </div>
  );
};

export default DownSupplier;
